export const GET_ACTIVE_ORDER_CARD_PAGINATION_READ = "GET_ACTIVE_ORDER_CARD_PAGINATION_READ";
export const GET_ACTIVE_ORDER_CARD_PAGINATION_UPDATE = "GET_ACTIVE_ORDER_CARD_PAGINATION_UPDATE";
export const GET_ACTIVE_ORDER_CARD_PAGINATION_RESET = "GET_ACTIVE_ORDER_CARD_PAGINATION_RESET";

export const GET_ACTIVE_ORDER_GRID_PAGINATION_READ = "GET_ACTIVE_ORDER_GRID_PAGINATION_READ";
export const GET_ACTIVE_ORDER_GRID_PAGINATION_UPDATE = "GET_ACTIVE_ORDER_GRID_PAGINATION_UPDATE";
export const GET_ACTIVE_ORDER_GRID_PAGINATION_RESET = "GET_ACTIVE_ORDER_GRID_PAGINATION_RESET";


export const GET_ALLOCATED_ORDER_CARD_PAGINATION_READ = "GET_ALLOCATED_ORDER_CARD_PAGINATION_READ";
export const GET_ALLOCATED_ORDER_CARD_PAGINATION_UPDATE = "GET_ALLOCATED_ORDER_CARD_PAGINATION_UPDATE";
export const GET_ALLOCATED_ORDER_CARD_PAGINATION_RESET = "GET_ALLOCATED_ORDER_CARD_PAGINATION_RESET";

export const GET_ALLOCATED_ORDER_GRID_PAGINATION_READ = "GET_ALLOCATED_ORDER_GRID_PAGINATION_READ";
export const GET_ALLOCATED_ORDER_GRID_PAGINATION_UPDATE = "GET_ALLOCATED_ORDER_GRID_PAGINATION_UPDATE";
export const GET_ALLOCATED_ORDER_GRID_PAGINATION_RESET = "GET_ALLOCATED_ORDER_GRID_PAGINATION_RESET";


export const GET_VEHICLE_REPORTING_CARD_PAGINATION_READ = "GET_VEHICLE_REPORTING_CARD_PAGINATION_READ";
export const GET_VEHICLE_REPORTING_CARD_PAGINATION_UPDATE = "GET_VEHICLE_REPORTING_CARD_PAGINATION_UPDATE";
export const GET_VEHICLE_REPORTING_CARD_PAGINATION_RESET = "GET_VEHICLE_REPORTING_CARD_PAGINATION_RESET";

export const GET_VEHICLE_REPORTING_GRID_PAGINATION_READ = "GET_VEHICLE_REPORTING_GRID_PAGINATION_READ";
export const GET_VEHICLE_REPORTING_GRID_PAGINATION_UPDATE = "GET_VEHICLE_REPORTING_GRID_PAGINATION_UPDATE";
export const GET_VEHICLE_REPORTING_GRID_PAGINATION_RESET = "GET_VEHICLE_REPORTING_GRID_PAGINATION_RESET";